export default function MeetingsBackground() {
  const meetingSections = [
    {
      title: "Today",
      meetings: [
        {
          title: "Weekly Standup - Engineering Team",
          time: "2:00 PM - 2:30 PM",
          attendees: "Sarah Johnson, Michael Chen, Alex Thompson",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          title: "Product Roadmap Review",
          time: "3:30 PM - 4:30 PM",
          attendees: "Marketing Team, Product Team",
          description:
            "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
        {
          title: "Client Presentation - Q4 Results",
          time: "5:00 PM - 6:00 PM",
          attendees: "Sales Team, Leadership",
          description:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        },
      ],
    },
    {
      title: "Tomorrow",
      meetings: [
        {
          title: "Design System Workshop",
          time: "10:00 AM - 11:30 AM",
          attendees: "Design Team, Frontend Developers",
          description:
            "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        },
        {
          title: "Budget Planning Session",
          time: "1:00 PM - 2:00 PM",
          attendees: "Finance Team, Department Heads",
          description:
            "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
        },
        {
          title: "Customer Feedback Analysis",
          time: "3:00 PM - 4:00 PM",
          attendees: "Customer Success, Product Team",
          description:
            "Totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt.",
        },
      ],
    },
  ]

  return (
    <div>
      {meetingSections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          <div className="bg-muted text-muted-foreground border-b px-4 py-2 text-sm font-medium">{section.title}</div>
          <div className="divide-y">
            {section.meetings.map((meeting, meetingIndex) => (
              <div key={meetingIndex} className="min-h-[100px] space-y-4 p-4">
                <div className="flex items-center justify-between">
                  <div className="space-y-2">
                    <div className="text-sm font-medium">{meeting.title}</div>
                    <div className="text-muted-foreground text-xs">{meeting.attendees}</div>
                  </div>
                  <div className="text-muted-foreground text-xs">{meeting.time}</div>
                </div>

                <div className="space-y-2">
                  <div className="text-sm">{meeting.description}</div>
                  <div className="text-muted-foreground text-xs">Meeting details and agenda items</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
